import {
  getPlanCategory,
  getOfferName,
  returnV2CalculatedTax,
} from '@smarty-nx/code-utils'
import { Plan, Price, Voucher } from '@smarty-nx/data'

import { TRACKING_CATEGORIES, DATA_LAYER_MODULE_TYPES } from '../constants'

export const planCardAttributes = (planData: Plan, isPreloadedSim?: boolean) =>
  planData && {
    'data-asset-id': planData.slug,
    'data-asset-type': DATA_LAYER_MODULE_TYPES.PRODUCTS,
    'data-asset_name': planData.slug,
    'data-asset_category': getPlanCategory(planData, isPreloadedSim),
    'data-asset_value_charge-type': 'monthly',
    'data-asset_value_display-gross': planData.finalPriceWithoutCredit?.value,
    'data-asset_value_display-tax': returnV2CalculatedTax(
      planData.finalPriceWithoutCredit?.value
    ),
  }

// select-plan (plan card in viewport)
export const planAttributes = (
  planData: Plan,
  position?: number,
  isPreloadedSim?: boolean
) =>
  planData
    ? {
        ...(planCardAttributes(planData, isPreloadedSim) || {}),
        'data-type': DATA_LAYER_MODULE_TYPES.PRODUCTS,
        'data-position': position,
        'data-asset_category': getPlanCategory(planData, isPreloadedSim),
        'data-asset_value_display-gross': planData.finalPrice.value,
        'data-asset_value_display-tax': returnV2CalculatedTax(
          planData.finalPrice.value
        ),
        ...voucherAttributesV2(
          planData.originalPrice,
          planData.finalPrice,
          planData.voucher,
          planData
        ),
      }
    : {}

/** Creates voucher attributes from v2 plan data (for the web-order onboard journey) */
const voucherAttributesV2 = (
  originalPrice: Price,
  finalPrice: Price,
  voucher: Voucher | null,
  plan: Plan
) => {
  const isRaf = !!window.localStorage.getItem('referrer_voucher_code')

  if (isRaf) {
    return {
      'data-lines_discount_coupon': 'RAF OFFER',
      'data-lines_discount_value_display-gross':
        originalPrice.value - finalPrice.value,
    }
  } else if (voucher) {
    return {
      'data-lines_discount_coupon': getOfferName(plan),
      'data-lines_discount_value_display-gross':
        originalPrice.value - finalPrice.value,
    }
  } else {
    return {}
  }
}

/** Creates order attributes from v2 plan data (for the web-order onboard journey) */
export const orderAttributes = (
  plan: Plan,
  paymentMethod?: string,
  creditUsed?: number,
  amountPaid?: number,
  isPreloaded = false,
  leadGenerator?: string,
  orderType?: string,
  portInOption?: string
) => {
  const { slug, originalPrice, finalPrice, voucher } = plan
  const calculateGross = finalPrice.value
  const calculatedTax = returnV2CalculatedTax(finalPrice.value)
  return {
    'data-cart_value_display-gross': calculateGross,
    'data-cart_value_display-tax': calculatedTax,
    'data-lines_id': slug,
    'data-lines_name': slug,
    'data-lines_category': getPlanCategory(plan, isPreloaded),
    'data-lines_quantity': 1,
    'data-lines_value_display-gross': calculateGross,
    'data-lines_value_display-tax': calculatedTax,
    'data-payment-method': paymentMethod,
    'data-payment-paid': amountPaid,
    'data-payment-credit': creditUsed,
    ...(isPreloaded ? { 'data-payment-credit-preloaded': calculateGross } : {}),
    ...voucherAttributesV2(originalPrice, finalPrice, voucher, plan),
    ...(leadGenerator && { 'data-lead-generator': leadGenerator }),
    ...(orderType && { 'data-order-type': orderType }),
    ...(portInOption && { 'data-selected-port-in-option': portInOption }),
  }
}

export const rafModalAttributes = {
  dataItemCategoryCopyLink: TRACKING_CATEGORIES.GENERAL,
  dataItemCategoryReferNow: TRACKING_CATEGORIES.GENERAL,
  dataItemNameCopyLink: 'copy-your-link',
  dataItemNameReferNow: 'refer-now',
}
